import React, { Fragment } from 'react';
import type { Stage } from 'corgi-types';

import { useGTMConfig } from 'common/components/GTM';

interface GtmNoScriptProps {
  environment: Stage;
}

const GtmNoscript = ({ environment }: GtmNoScriptProps) => {
  const { noscript } = useGTMConfig(environment);

  return (
    <Fragment>
      {noscript.global}
      {noscript.region}
    </Fragment>
  );
};

export default GtmNoscript;
